import React from 'react'
import { Link } from 'react-router-dom'

import "./Success.scss"


const Cancel = () => {
  return (
    <main className="cancel-page">
      <h1>Uh oh, something went wrong!</h1>
      <p> You can still access your item(s) in the <Link to="/cart">cart</Link> if you wish to proceed with your order</p>
      
      
    </main>
  )
}

export default Cancel
